(function () {
  var catalog = document.querySelector('.wholesale-monthly-catalog');
  if (!catalog) return;

  function normalizeCatalogSearchState() {
    if (catalog.getAttribute('data-wm-search-mode') !== 'true') return;

    var params = new URLSearchParams(window.location.search);
    var metalByTag = {
      'Oro Laminado': { key: 'gold-filled', label: 'Gold Filled / Oro Laminado' },
      'Rodio Laminado': { key: 'white-gold-filled', label: 'White Gold Filled / Laminado Blanco' },
      'Plata 925': { key: 'silver-925', label: 'Silver 925 / Plata 925' },
      'Acero Inoxidable': { key: 'stainless-steel', label: 'Stainless Steel / Acero' }
    };
    var typeByCategory = {
      earrings: 'Earrings', hoops: 'Hoops', bracelets: 'Bracelets', bangles: 'Bangles', rings: 'Rings',
      necklaces: 'Necklaces', 'necklace-sets': 'Necklace Sets', pendants: 'Pendants',
      'earring-pendant-sets': 'Earring and Pendant Sets', anklets: 'Anklets', rosaries: 'Rosaries',
      brooches: 'Brooches', findings: 'Findings', 'jewelry-supplies': 'Jewelry Supplies'
    };
    var categoryByType = {};
    for (var categoryKey in typeByCategory) {
      if (Object.prototype.hasOwnProperty.call(typeByCategory, categoryKey)) categoryByType[typeByCategory[categoryKey]] = categoryKey;
    }

    var activeTag = params.get('filter.p.tag');
    var activeType = params.get('filter.p.product_type');
    var metal = metalByTag[activeTag];
    if (!metal) return;
    var category = categoryByType[activeType] || 'newest';
    var heading = catalog.querySelector('[data-wm-catalog-heading]');
    if (heading) heading.textContent = metal.label;

    function setActive(selector, attribute, value) {
      var nodes = catalog.querySelectorAll(selector);
      for (var index = 0; index < nodes.length; index += 1) {
        var isActive = nodes[index].getAttribute(attribute) === value;
        nodes[index].classList.toggle('is-active', isActive);
        if (isActive) nodes[index].setAttribute('aria-current', 'page');
        else nodes[index].removeAttribute('aria-current');
      }
    }
    setActive('.wm-catalog__metal', 'data-wm-metal', metal.key);
    setActive('.wm-catalog__category', 'data-wm-category', category);

    var searchForm = catalog.querySelector('.wm-catalog__search');
    if (searchForm) {
      var tagInput = searchForm.querySelector('input[name="filter.p.tag"]');
      if (tagInput) tagInput.value = activeTag;
      var typeInput = searchForm.querySelector('input[name="filter.p.product_type"]');
      if (activeType && !typeInput) {
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'filter.p.product_type';
        searchForm.appendChild(typeInput);
      }
      if (typeInput) typeInput.value = activeType || '';
    }

    function catalogSearchUrl(metalKey, categoryKey) {
      var selectedMetal = null;
      for (var tag in metalByTag) {
        if (Object.prototype.hasOwnProperty.call(metalByTag, tag) && metalByTag[tag].key === metalKey) selectedMetal = tag;
      }
      var nextParams = new URLSearchParams();
      nextParams.set('view', 'wholesale-catalog');
      nextParams.set('type', 'product');
      nextParams.set('filter.p.tag', selectedMetal);
      if (typeByCategory[categoryKey]) nextParams.set('filter.p.product_type', typeByCategory[categoryKey]);
      if (params.get('q')) nextParams.set('q', params.get('q'));
      return '/search?' + nextParams.toString();
    }
    var metals = catalog.querySelectorAll('.wm-catalog__metal[data-wm-metal]');
    for (var metalIndex = 0; metalIndex < metals.length; metalIndex += 1) {
      metals[metalIndex].href = catalogSearchUrl(metals[metalIndex].getAttribute('data-wm-metal'), category);
    }
    var categories = catalog.querySelectorAll('.wm-catalog__category[data-wm-category]');
    for (var categoryIndex = 0; categoryIndex < categories.length; categoryIndex += 1) {
      categories[categoryIndex].href = catalogSearchUrl(metal.key, categories[categoryIndex].getAttribute('data-wm-category'));
    }
  }

  normalizeCatalogSearchState();

  var paginationLinks = catalog.querySelectorAll('.wm-catalog__pagination a');
  for (var i = 0; i < paginationLinks.length; i += 1) {
    paginationLinks[i].addEventListener('click', function () {
      window.sessionStorage.setItem('wmCatalogScrollTop', '1');
    });
  }
  if (window.sessionStorage.getItem('wmCatalogScrollTop') === '1') {
    window.sessionStorage.removeItem('wmCatalogScrollTop');
    window.setTimeout(function () { catalog.scrollIntoView({ block: 'start' }); }, 0);
  }

  var imageToggles = catalog.querySelectorAll('[data-wm-image-toggle]');
  for (var j = 0; j < imageToggles.length; j += 1) {
    (function (imageToggle) {
      var startX = null;
      var suppressClick = false;
      imageToggle.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
      });
      imageToggle.addEventListener('pointerup', function (event) {
        if (startX === null || event.pointerType === 'mouse') return;
        if (Math.abs(event.clientX - startX) > 26) {
          event.preventDefault();
          imageToggle.classList.toggle('is-next-image');
          suppressClick = true;
        }
        startX = null;
      });
      imageToggle.addEventListener('pointercancel', function () { startX = null; });
      imageToggle.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        suppressClick = false;
      });
    }(imageToggles[j]));
  }

  function shakeCart() {
    var carts = document.querySelectorAll('.mini-cart, .cart-link, .header-cart, .cart-icon, .shopping-cart, a[href="/cart"], a[href^="/cart?"]');
    for (var k = 0; k < carts.length; k += 1) {
      carts[k].classList.remove('wm-cart-added');
      void carts[k].offsetWidth;
      carts[k].classList.add('wm-cart-added');
      window.setTimeout((function (cart) { return function () { cart.classList.remove('wm-cart-added'); }; }(carts[k])), 650);
    }
  }

  function showCartNotice(message) {
    var oldNotice = document.querySelector('.wm-catalog-cart-notice');
    if (oldNotice) oldNotice.parentNode.removeChild(oldNotice);
    var notice = document.createElement('div');
    notice.className = 'wm-catalog-cart-notice';
    notice.setAttribute('role', 'status');
    notice.textContent = message;
    document.body.appendChild(notice);
    window.setTimeout(function () {
      if (notice.parentNode) notice.parentNode.removeChild(notice);
    }, 2600);
  }

  function updateCartCount(cart) {
    var countNodes = document.querySelectorAll('.cart-count, .cart_count, .cart-items-count, [data-cart-count]');
    for (var l = 0; l < countNodes.length; l += 1) countNodes[l].textContent = cart.item_count;
  }

  var cartForms = catalog.querySelectorAll('form.wm-product-card__cart');
  for (var m = 0; m < cartForms.length; m += 1) {
    (function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        var originalMarkup = button.innerHTML;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: new FormData(form)
        }).then(function (response) {
          if (!response.ok) return response.json().then(function (error) { throw error; });
          return response.json();
        }).then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
        }).then(function (response) {
          return response.ok ? response.json() : null;
        }).then(function (cart) {
          if (cart) updateCartCount(cart);
          button.classList.add('is-added');
          button.innerHTML = '<span class="wm-product-card__cart-plus" aria-hidden="true">✓</span><span class="visually-hidden">Added to cart / Agregado al carrito</span>';
          shakeCart();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'wholesale-monthly-catalog', cart: cart } }));
          showCartNotice('Added to cart / Agregado al carrito');
          window.setTimeout(function () {
            button.classList.remove('is-added');
            button.innerHTML = originalMarkup;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }, 1500);
        }).catch(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          showCartNotice('Could not add this item. Please try again. / No se pudo agregar este artículo.');
        });
      });
    }(cartForms[m]));
  }
}());

